import { render, staticRenderFns } from "./ImageShow.vue?vue&type=template&id=78e07d89"
import script from "./ImageShow.vue?vue&type=script&lang=ts"
export * from "./ImageShow.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports